module.exports = __webpack_public_path__ + "20250828d091945t/img/learning-cuate-icon.044b9169.png";